module.exports = __webpack_public_path__ + "fd05363972c48e09db882666d9056f78.png";